var _rect, _g, _rect2, _path, _g2, _path2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 512,
    height: 512,
    fill: "#496e2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M407.816,147.517a77.927,77.927,0,0,0-31.922-92.305,77.914,77.914,0,1,1-51.4,143.263A77.928,77.928,0,0,0,407.816,147.517Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M337.957,45.589,327.012,59.73l-16.83-6.038L320.249,68.47,309.306,82.61,326.471,77.6,336.539,92.38l.541-17.872L354.245,69.5l-16.829-6.037Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M367.509,91.668l-10.944,14.141L339.734,99.77,349.8,114.549l-10.945,14.14,17.167-5.008,10.067,14.779.541-17.873L383.8,115.58l-16.832-6.039Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M285.852,62.371l-10.945,14.14-16.83-6.038,10.067,14.778L257.2,99.391l17.165-5.006,10.069,14.778.541-17.873,17.165-5.007-16.829-6.039Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M284.652,115.154,273.707,129.3l-16.83-6.039,10.068,14.778L256,152.175l17.166-5.006,10.068,14.778.541-17.874,17.166-5.006-16.831-6.039Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M334.879,133.175l-10.944,14.141L307.1,141.277l10.068,14.778L306.227,170.2l17.167-5.006,10.067,14.778L334,162.093l17.167-5.007-16.832-6.038Z",
    fill: "#f0f0f0"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 133.565,
    height: 512,
    transform: "translate(41.74)",
    fill: "#d80027"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M92.712,134.783,70.35,118.125V94.569L92.712,77.911h31.625L146.7,94.569v23.556l-22.362,16.658Z",
    fill: "#f0f0f0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M108.524,77.911H92.712L70.35,94.569v11.516h38.174Z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M108.524,134.783h15.813L146.7,118.125V106.109H108.524Z",
    fill: "#ff9811"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M92.712,434.091,70.35,417.434V393.876l22.362-16.658h31.625L146.7,393.876v23.558l-22.362,16.657Z",
    fill: "#f0f0f0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M108.524,377.218H92.712L70.35,393.876v11.517h38.174Z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M108.524,434.091h15.813L146.7,417.434V405.416H108.524Z",
    fill: "#ff9811"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M92.712,284.437,70.35,267.779V244.223l22.362-16.659h31.625L146.7,244.223v23.556l-22.362,16.658Z",
    fill: "#496e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M147.482,321.087h-9.74v-9.739H120.626l-12.1-12.1-12.1,12.1H79.307v9.739h-9.74v19.48h9.74v9.739H96.421l12.1,12.1,12.1-12.1h17.116v-9.739h9.74Z",
    fill: "#496e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M147.482,171.434h-9.74V161.7H120.626l-12.1-12.1-12.1,12.1H79.307v9.739h-9.74v19.479h9.74v9.739H96.421l12.1,12.1,12.1-12.1h17.116v-9.739h9.74Z",
    fill: "#496e2d"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 22.261,
    height: 22.261,
    transform: "translate(97.391 244.87)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 11.13,
    cy: 11.13,
    r: 11.13,
    transform: "translate(97.392 170.04)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 11.13,
    cy: 11.13,
    r: 11.13,
    transform: "translate(97.392 319.7)",
    fill: "#d80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.716a4ccea2580cee38825575da6693d6.svg";
export { ForwardRef as ReactComponent };